import { useEffect, useState } from "react";
import { CapacitorHttp } from "@capacitor/core";
import { collection, getDocs, orderBy, query, getFirestore } from "firebase/firestore";

const History1 = () => {
  const [chatLogs, setChatLogs] = useState({}); // key = YYYY-MM-DD, value = array of logs

  useEffect(() => {
    const fetchLogs = async () => {
      const childId = localStorage.getItem("child_id");
      if (!childId) return;

      try {
        const isWeb = !window.Capacitor?.isNativePlatform?.();

        if (isWeb) {
          // 👉 Web App: dùng SDK Firestore
          const db = getFirestore();
          const q = query(
            collection(db, "chat_logs", childId, "history"),
            orderBy("time")
          );
          const snapshot = await getDocs(q);

          const logsByDate = {};
          snapshot.forEach((doc) => {
            const data = doc.data();
            const date = data.date;
            if (!logsByDate[date]) logsByDate[date] = [];
            logsByDate[date].push(data);
          });

          setChatLogs(logsByDate);
        } else {
          // 👉 Capacitor: dùng CapacitorHttp
          const url = `https://firestore.googleapis.com/v1/projects/gigitherobot-4550d/databases/(default)/documents/chat_logs/${childId}/history?pageSize=1000`;

          const response = await CapacitorHttp.get({ url });
          if (response.status !== 200) {
            console.error("Lỗi lấy dữ liệu:", response);
            return;
          }

          const logsByDate = {};

          (response.data.documents || []).forEach((doc) => {
            const fields = doc.fields || {};
            const user = fields.user?.stringValue || "";
            const assistant = fields.reply?.stringValue || "";
            const mode = fields.fashion?.stringValue || "";
            const date = fields.date?.stringValue || "unknown";

            if (!logsByDate[date]) logsByDate[date] = [];
            logsByDate[date].push({ user, assistant, mode });
          });

          setChatLogs(logsByDate);
        }
      } catch (err) {
        console.error("❌ Lỗi tải lịch sử:", err);
      }
    };

    fetchLogs();
  }, []);

  return (
    <div className="min-h-screen w-full bg-light-primary-key-background flex flex-col items-center overflow-y-auto px-4 pt-6 pb-[calc(env(safe-area-inset-bottom)+100px)] font-text-regular-lowercase text-base text-light-text leading-normal tracking-normal">
      <h2 className="text-2xl font-semibold text-dark-text text-center mb-8">
        📚 Lịch sử trò chuyện của bé
      </h2>

      {Object.keys(chatLogs).length === 0 ? (
        <div className="text-center text-lg text-gray-500 mt-10">
          Chưa có dữ liệu nào...
        </div>
      ) : (
        <div className="w-full max-w-md flex flex-col gap-8">
          {Object.entries(chatLogs).map(([date, logs]) => (
            <div key={date}>
              <h3 className="text-lg font-bold text-pink-500 mb-4">📅 {date}</h3>
              <div className="flex flex-col gap-4">
                {logs.map((log, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl shadow-md p-4 border border-gray-200"
                  >
                    <p className="mb-2">
                      <strong>🧒 Bé:</strong> {log.user}
                    </p>
                    <p className="mb-2">
                      <strong>🤖 Gigi:</strong> {log.assistant}
                    </p>
                    {log.mode && (
                      <p className="text-xs text-gray-500 italic">
                        🎮 Chế độ: {log.mode}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default History1;

